// extracted by mini-css-extract-plugin
module.exports = {"root":"Sessions_root__toDV6","paper":"Sessions_paper__3nln-"};